import api from '@services/api.service'
import { createAsyncThunk } from '@reduxjs/toolkit'

const authorEndpoint = 'authors/'

export const fetchAllAuthors = createAsyncThunk('author/fetchAll', async () => {
  const response = await api.get(`${authorEndpoint}`)

  if (response.status !== 200) {
    throw new Error('Error during login')
  }
  return response.data
})
